// | ------------------------------------------------------------------------
// | GSAP Scroll Animations - Sectors ScrollSpy Content
// | ------------------------------------------------------------------------

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// | ------------------------------------------------------------------------

// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

// | ------------------------------------------------------------------------

const scrollSpy = document.querySelector(".sectors-scrollspy");
const scrollSections = gsap.utils.toArray(".sector-content");
const links = gsap.utils.toArray(".sector-name-card");

function createSectorTriggers(showMarkers) {

  scrollSections.forEach((section, i) => {
    const link = links[i];
    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "bottom center",
      onEnter: () => link.classList.add("active"),
      onEnterBack: () => link.classList.add("active"),
      onLeave: () => link.classList.remove("active"),
      onLeaveBack: () => link.classList.remove("active"),
      markers: showMarkers,
      id: "sector-trigger"
    });
  });
}

function sectorsScrollSpy(showMarkers) {
  let matchMedia = gsap.matchMedia();

  matchMedia.add("(min-width: 1000px) and (min-height: 664px)", () => {
    // Remove static layout
    scrollSpy.classList.remove("static");

    createSectorTriggers(showMarkers);

    // Make side links 'sticky'
    ScrollTrigger.create({
      trigger: ".sectors-side",
      start: "top top",
      endTrigger: ".office-cta-section",
      end: "top bottom+=70",
      pin: ".sectors-side",
      pinSpacing: false,
      markers: showMarkers,
    });

    // Make window 'sticky'
    ScrollTrigger.create({
      trigger: "#sector-window",
      start: "top top",
      endTrigger: ".office-cta-section",
      end: "top bottom+=70",
      pin: "#sector-window",
      pinSpacing: false,
      markers: showMarkers,
      id:"sector-window"
    });


    return () => {
      scrollSpy.classList.add("static");
    };
  });

  // Refresh matchMedia to ensure conditions are evaluated on load
  //gsap.matchMediaRefresh();
}

export { sectorsScrollSpy };
